import { useCatalogActionsContext } from "@components/Actions/CatalogActions/CatalogActionsContext";
import CatalogItem from "@components/Actions/CatalogItems/Base";
import Icon from "@components/Atoms/Icon";
import { LeftNavigationTab } from "@components/Layouts/LeftNavigationTabs/LeftNavigationTab";
import t from "@ext/localization/locale/translate";
import type { ReactNode } from "react";

interface AiPromptItemProps {
	children?: ReactNode;
}

const AiPromptItem = ({ children }: AiPromptItemProps) => {
	const { onToggleTab } = useCatalogActionsContext();

	return (
		<CatalogItem
			renderLabel={(Item) => (
				<Item onSelect={() => onToggleTab(LeftNavigationTab.Prompt)}>
					<Icon code="square-chevron-right" />
					{t("ai.ai-prompts")}
				</Item>
			)}
		>
			{children}
		</CatalogItem>
	);
};

export default AiPromptItem;
